export default __webpack_public_path__ + "6d8b6e5c6a19c329d5fadab8cae496c0.svg";